module.exports = __webpack_public_path__ + "static/media/7.f7c557ca.png";